import { Loader as LoaderIcon } from '@stratascratch/icons'
import { cn } from '../lib/utils'
import './Loader.css'

interface Props {
  className?: string
}

function Loader({ className = '' }: Props) {
  return <LoaderIcon className={cn('Loader__icon', className)} />
}

export default Loader
